let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8wRvQ")).then(() => parcelRequire('ejQjV'));